import React from 'react'
import { useTranslation } from 'react-i18next'
import HeroImg from '../../../assets/images/company-formation/offshore-company-formation/hero-img.png'
import BannerImg from '../../../assets/images/company-formation/offshore-company-formation/banner-img.png'
import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../../components/Constant/List/List";
import { TiTick } from "react-icons/ti";
import { GoDotFill } from "react-icons/go";
import Button from "../../../components/Constant/button/Button";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import CTA from "../../../components/Constant/cta/CTA";
import SEO from "../../../utils/SEO";

function MaltaCompanyFormation() {
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.malta-company-formation.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });
    const withIcon = (k, icon) => (obj(k) || []).map((it) => ({ ...it, icon }));

    const BreadCrumbsData = [
        { name: tp('breadcrumb.home', 'Offshore Advisory'), link: '/' },
        { name: tp('breadcrumb.self', 'Offshore Company Formation'), link: '/offshore-company-formation' },
    ];

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/malta-company-formation"
            />
            <section className='section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='container'>
                    <h1 className='section-title'>{tp('h1')}</h1>
                    <br/>
                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>{tp('subtitle')}</h3>
                            <p className='page-paragraph' dangerouslySetInnerHTML={{ __html: tp('intro') }} />

                            <PageList items={(obj('checklist') || []).map((title) => ({ title, icon: TiTick }))} />

                            <Button
                                text={tp('proposalButton')}
                                link="/consultation"
                                type="primary"
                                size="large"
                            />
                        </div>

                        <HeroRightImage src={HeroImg}/>
                    </div>
                    <BannerPageImg src={BannerImg}/>
                    <br/><br/>

                    <div className='flex-start'>
                        <h3 className='page-title'>{tp('why.title')}</h3>
                        <PageList items={withIcon('why.items', GoDotFill)} />

                        <h3 className='page-title'>{tp('types.title')}</h3>
                        {(obj('types.groups') || []).map((g, i) => (
                            <React.Fragment key={i}>
                                <p className='page-subtitle'>{g.label}</p>
                                <PageList items={(g.items || []).map((it) => ({ ...it, icon: GoDotFill }))} />
                            </React.Fragment>
                        ))}

                        <h3 className='page-title'>{tp('requirements.title')}</h3>
                        <PageList items={withIcon('requirements.items', GoDotFill)} />

                        <h3 className='page-title'>{tp('benefits.title')}</h3>
                        <PageList items={withIcon('benefits.items', GoDotFill)} />

                        <h3 className='page-title'>{tp('process.title')}</h3>
                        <PageList items={withIcon('process.items', GoDotFill)} />

                        <h3 className='page-title'>{tp('timeline.title')}</h3>
                        <PageList items={withIcon('timeline.items', GoDotFill)} />

                        <h3 className='page-title'>{tp('uses.title')}</h3>
                        <PageList items={withIcon('uses.items', GoDotFill)} />

                        <h3 className='page-title'>{tp('whyUs.title')}</h3>
                        <PageList items={withIcon('whyUs.items', GoDotFill)} />

                    </div>

                    <FAQList title={tp('faq.title')} data={obj('faq.items')} />

                    <Testimonials title={tp('testimonials.title')} testimonials={obj('testimonials.items')}/>

                    <CTA
                        title={tp('cta.title')}
                        description={tp('cta.description')}
                        buttonText={tp('cta.button')}
                        buttonLink="/consultation"
                    />
                </div>
            </section>
        </main>
    )
}

export default MaltaCompanyFormation
